import React, { useEffect, useState } from "react";
import PageTitle from "../store/PageTitle";
import Header from "./Header";
// import Products from "./Products";
import Ads from "./Ads";
import Loader from "./Loader";
import { fetchAds } from "../store/action/adsAction";
import { useDispatch, useSelector } from "react-redux";
import Cart from "../checkout/Cart";
import HighLightedProducts from "./HighLightedProducts";
import ProductSlider from "./ProductSlider";
import "./home.css";
import "./style.css";
import "./productSlider.css";
// import ProductLayout from "./ProductLayout";

const serverUrl = process.env.REACT_APP_SERVER_URL;

const api = {
  fetchHighLight: async () => {
    const response = await fetch(`${serverUrl}/highlights-client`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    if (!response.ok) {
      throw new Error("Failed to fetch highlights");
    }
    return await response.json();
  },
};

function Home({
  toggleLogin,
  products,
  loading,
  error,
  isCartOpen,
  toggleCart,
  closeCart,
  showProducts,
  setShowProducts,
  closeCartRef,
  currentPage,
  setCurrentPage,
  activeCategory,
  setActiveCategory,
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAds());
  }, [dispatch]);

  const { ads } = useSelector((state) => state.ads);

  const bannerAds = ads
    ? ads.filter((ad) => ad.position === "banner" && ad.is_active)
    : [];

  const footerAds = ads
    ? ads.filter((ad) => ad.position === "footer" && ad.is_active)
    : [];

  const [highlights, setHighlights] = useState([]);
  const [highloader, setHighLoader] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  console.log(searchTerm, "searchTerm");

  useEffect(() => {
    fetchHighLight();
  }, []);

  const fetchHighLight = async () => {
    setHighLoader(true);
    try {
      const data = await api.fetchHighLight();
      setHighlights(data || []);
    } catch (err) {
      console.error("Error fetching Highlights:", err);
    } finally {
      setHighLoader(false);
    }
  };

  const handleFeaturedClick = (category, productName) => {
    setShowProducts(true);
    setActiveCategory(category);
    setSearchTerm(productName);
  };

  // const handleShowAllProducts = () => {
  //   setShowProducts(true);
  //   setActiveCategory("All");
  //   setSearchTerm("");
  // };

  // const handleCloseProducts = () => {
  //   setShowProducts(false);
  //   setActiveCategory("All");
  //   setSearchTerm("");
  // };

  // const handleBackToProducts = () => {
  //   setShowProducts(true);
  // };

  const chunkArray = (array, size) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  };

  const FeaturedCard = (Array.isArray(products) ? products : []).filter(
    (card) => card?.onSlider === true,
  );

  // Split into groups of 8
  const sliderGroups = chunkArray(FeaturedCard, 8);

  // Split highlights into first card, middle cards, last card
  const featured = highlights.filter((p) => p.type === "featured");
  const firstCard = featured[0] ? [featured[0]] : [];

  const lastCard = featured.length > 1 ? [featured[featured.length - 1]] : [];

  return (
    <div>
      <PageTitle title="City Gamers & Electronics" />
      <div>
        <Header ads={bannerAds} />

        {isCartOpen && (
          <Cart
            closeCart={closeCart}
            toggleLogin={toggleLogin}
            closeCartRef={closeCartRef}
          />
        )}

        {/* Render first featured card */}
        {firstCard.map((product) => (
          <HighLightedProducts
            key={product.id}
            products={[product]}
            onFeaturedClick={handleFeaturedClick}
            highloader={highloader}
          />
        ))}

        {sliderGroups[0] && (
          <ProductSlider
            FeaturedCard={sliderGroups[0]}
            onFeaturedClick={handleFeaturedClick}
          />
        )}

        {/* Render last featured card */}
        {lastCard.map((product) => (
          <HighLightedProducts
            key={product.id}
            products={[product]}
            onFeaturedClick={handleFeaturedClick}
            highloader={highloader}
          />
        ))}

        {/* 🔽 ADD ProductSlider AGAIN at the bottom of all HighLightedProducts */}
        {sliderGroups[1] && <ProductSlider FeaturedCard={sliderGroups[1]} />}

        <Ads ads={footerAds} />
        {loading && <Loader />}
      </div>
    </div>
  );
}

export default Home;
